import { englishMessages } from './common';

export default {
  ...englishMessages,
  'search.result.buy-online': 'Virtual Showroom',
  CONFIGURATOR: ' Configure your car',
};
